import { Stack } from 'src/design/atoms/Stack';
import React from 'react';
import { useWbs } from 'src/routes/Jobs/WBS/contexts/WbsContext';
import { AdjustmentsTable } from './AdjustmentsTable';
import { EditAdjustmentForm } from './EditAdjustmentForm';
import { SystemAdjustmentPanel } from './SystemAdjustmentPanel';

export const AdjustmentsTab: React.FC = () => {
  const { selectedAdjustment, selectAdjustment, onAdjustmentSaved } = useWbs();

  const handleAdjustmentSaved = async () => {
    await onAdjustmentSaved();
  };

  const handleAdjustmentSelected = (adjustment: any) => {
    selectAdjustment(adjustment);
  };

  const handleClose = () => {
    selectAdjustment(null);
  };

  // Determine which panel to show
  const renderAdjustmentPanel = () => {
    if (selectedAdjustment?.isSystemGenerated) {
      return (
        <SystemAdjustmentPanel
          adjustment={selectedAdjustment}
          onClose={handleClose}
        />
      );
    }

    return (
      <EditAdjustmentForm
        onSave={handleAdjustmentSaved}
        onCancel={handleClose}
      />
    );
  };

  return (
    <Stack gap="md">
      {renderAdjustmentPanel()}
      <AdjustmentsTable onAdjustmentSelect={handleAdjustmentSelected} />
    </Stack>
  );
};
